
require('es6-object-assign').polyfill();

import Logger from 'js-logger';

//import pkg from '../../package.json';

import config from './constants/Config';

import GameSounds from './sound/GameSounds';
import PhaserUtils from './utils/PhaserUtils';
import DebugUtils from './utils/debug/DebugUtils';
import GameSizeManager from './utils/display/GameSizeManager';

import GameTurnService from './server/GameTurnService';
import LogicCore from './logic/LogicCore';
import BootState from './states/BootState';
import PreloaderState from './states/PreloaderState';
import GameState from './states/GameState';


// Log messages will be written to the window's console.
Logger.useDefaults();

// only show WARN and above in build (changed by grunt)
Logger.setLevel((process.env.NODE_ENV === 'production') ? Logger.WARN : Logger.DEBUG);

// First log message
Logger.info('Skeeball v.', config.version);

//console.log('something changed');

window.onload = function() {

  // Setup facebook
  if (STATE_INITIALS === 'GA') {

    // https://www.facebook.com/pg/GeorgiaLottery
    // GA lottery page id = 72536951180
    // jig&cam page id = 372149176159966
    // publish comment: {post-id}/comments
    // fields:
    // message=hello
    // (need page access token)
    // 72536951180_10156288205866181/comments
    //
    // To get 'page access token'
    // -Go to https://developers.facebook.com/tools/explorer/
    // (while logged in as Georgia Lottery owner)
    // -Click 'Get Token' and then select 'Get Page Access Token'
    // -A popup window will ask if 'Georgia Lottery Skee-Ball' can manage your pages
    // - need 'manage_pages,publish_pages' permissions
    /*
    console.log('connecting to FB...');
    window.fbAsyncInit = function() {
      FB.init({
        appId      : '2221718758047202',
        xfbml      : true,
        version    : 'v3.0'
      });
      FB.AppEvents.logPageView();
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    */
  }

  // create the game with some defaults
  const game = new Phaser.Game(config.minWidthLandscape, config.minHeightLandscape, Phaser.AUTO, '');


  // global access
  game.services = {
    server: Object.create(GameTurnService).init()
  };
  game.logic = Object.create(LogicCore).init(game);

  // init utils
  PhaserUtils.init(game, config);

  // sound
  game.soundManager = Object.create(GameSounds).initLibrary(game);

  // sizing
  game.sizeManager = Object.create(GameSizeManager).init(game, config, (config.debug) ? DebugUtils : null);

  // create states, and Boot
  game.state.add('BootState', BootState);
  game.state.add('PreloaderState', PreloaderState);
  game.state.add('GameState', GameState);

  game.state.start('BootState');

};



// WEBPACK FOOTER //
// ./app/src/index.js